import {List} from "@mui/material";

interface MobileMenuListProps {
    children: React.ReactNode;
}

export default function MobileMenuList(props: Readonly<MobileMenuListProps>) {
    const {children} = props;

    return (
        <List style={{width: "100%", marginTop: 8, marginBottom: 8}} disablePadding>
            {children}
        </List>
    );
}